import { Component, OnInit, ViewEncapsulation, Inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PlanSubscriptionComponent } from './components/plan-subscription/plan-subscription.component';
import { PaymentMethodsComponent } from './components/payment-methods/payment-methods.component';
import { PaymentHistoryComponent } from './components/payment-history/payment-history.component';
import { BillingDataComponent } from './components/billing-data/billing-data.component';
import { TabPermissionService } from '../../../../../core/auth/tab-permission.service';

export interface BillingMenuItem {
    id: string;
    title: string;
    icon: string;
    permissionKey: string;
    active?: boolean;
}

@Component({
    selector: 'billing-modal',
    templateUrl: './billing-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        PlanSubscriptionComponent,
        PaymentMethodsComponent,
        PaymentHistoryComponent,
        BillingDataComponent
    ]
})
export class BillingModalComponent implements OnInit {
    menuItems: BillingMenuItem[] = [
        {
            id: 'plan-subscription',
            title: 'Plano e Assinatura',
            icon: 'mat_outline:stars',
            permissionKey: 'bil-plan',
            active: true
        },
        {
            id: 'payment-methods',
            title: 'Métodos de pagamento',
            icon: 'mat_outline:credit_card',
            permissionKey: 'bil-payment-methods'
        },
        {
            id: 'payment-history',
            title: 'Histórico de pagamentos',
            icon: 'mat_outline:receipt_long',
            permissionKey: 'bil-invoices'
        },
        {
            id: 'billing-data',
            title: 'Dados da igreja',
            icon: 'mat_outline:business',
            permissionKey: 'bil-plan'
        }
    ];

    visibleMenuItems: BillingMenuItem[] = [];
    selectedMenuItem: string = 'plan-subscription';
    isMenuOpen: boolean = true;
    window = window;

    constructor(
        public dialogRef: MatDialogRef<BillingModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _tabPermission: TabPermissionService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
        if (window.innerWidth < 600) {
            this.isMenuOpen = false;
        }
    }

    ngOnInit(): void {
        this._tabPermission.loadPermissions(true).subscribe(() => {
            this.visibleMenuItems = this.menuItems.filter(
                item => this._tabPermission.canAccess(item.permissionKey)
            );
            if (this.visibleMenuItems.length > 0 && !this.visibleMenuItems.find(i => i.id === this.selectedMenuItem)) {
                this.selectedMenuItem = this.visibleMenuItems[0].id;
            }
            this._changeDetectorRef.markForCheck();
        });
    }

    selectMenuItem(itemId: string): void {
        this.visibleMenuItems.forEach(item => item.active = item.id === itemId);
        this.selectedMenuItem = itemId;

        if (window.innerWidth < 600) {
            this.isMenuOpen = false;
        }
    }

    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }

    getMenuItemTitle(itemId: string): string {
        const item = this.menuItems.find(i => i.id === itemId);
        return item ? item.title : '';
    }

    closeModal(): void {
        this.dialogRef.close();
    }
}
